export class TransformData {
  phase?: number | null;
  high_inlet_temperature?: number;
  inlet_temperature?: number;
  pressure?: number;
  water_inlet_temperature?: number;
  voltage?: number | null;
  frequency?: number | null;
  air_flow?: number;
  ambient_temperature?: number;
  unit?: string | null;
  dew_point?: number;
  desiccant_dew_point?: string;
  options?: any | null;
  max_inlet_temperature?: number | null;
  pressureDrop?: number | null;
  min_inlet_temperature?: number | null;
}

export interface PayloadSensorValues {
  sensorValues?: TransformData;
}
